import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DynamicHooksComponent } from 'ngx-dynamic-hooks';
import { Product } from 'product-shared';
import { ProductBoxFeaturesComponent } from '../product-box-features/product-box-features.component';

@Component({
  selector: 'lib-product-box-description',
  templateUrl: './product-box-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, DynamicHooksComponent, ProductBoxFeaturesComponent],
})
export class ProductBoxDescriptionComponent {
  public product = input.required<Product>();
  public lightMode = input(false);
}
